import { Tooltip, type TooltipProps } from '@civilgrid/ui/components';
import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';
import type { ReactNode } from 'react';

interface PillProps {
  label: string;
  tooltip?: ReactNode;
  value: string | number;
  last?: boolean;
  side?: TooltipProps['side'];
}

export default function SummaryPill({ label, value, tooltip, last, side }: PillProps) {
  return (
    <Tooltip
      side={side}
      className="w-64"
      text={tooltip}
      data-testid={`summary-pill-${kebabCase(label)}`}
      triggerClassName={classNames('flex cursor-help flex-col items-center space-y-1 px-2', {
        'border-r-1': !last,
      })}
    >
      <span className="text-2xl text-secondary">{value}</span>
      <span className="flex w-20 items-center justify-center space-x-1 text-center text-xs">{label}</span>
    </Tooltip>
  );
}
